export const environment = {
  production: true,
  base_url: 'https://locana.es:3000/api'
};
